<template>
  <div class="block">
    <template v-if="items">
      <p v-if="title" class="mainTitle">{{ title }}</p>
      <div class="inner">
        <TwoBlocks :items="twoItems"></TwoBlocks>
        <FiveBlocks :items="fiveItems"></FiveBlocks>
      </div>
    </template>
  </div>
</template>

<script>
import TwoBlocks from "./twoBlocks.vue";
import FiveBlocks from "./fiveBlocks.vue";

export default {
  name: "TwoUpFiveDown",
  components: {
    TwoBlocks,
    FiveBlocks,
  },
  props: {
    items: {
      type: Array,
    },
  },
  data() {
    return {
      title: "",
      twoItems: null,
      fiveItems: null,
    };
  },
  created() {
    if(this.items) {
      this.twoItems = this.items.slice(0, 2);
      this.fiveItems = this.items.slice(2);
    }
  },
};
</script>
